export const filterMenuData = (menuData, rolePermissions) => {
  const seenIds = new Set();
  const filtered = menuData.filter((menuItem) => {
    if (seenIds.has(menuItem.id)) {
      console.warn(`Duplicate menu item ID: ${menuItem.id}`);
      return false;
    }
    seenIds.add(menuItem.id);

    // Always include Feedback and Support
    if (
      menuItem.permissionCategoryName === "Feedback" ||
      menuItem.permissionCategoryName === "Help & Support Center"
    ) {
      return true;
    }

    // Check permission for other menu items
    const hasPermission = rolePermissions.some(
      (permission) =>
        permission.permissionCategoryId === menuItem.permissionCategoryId &&
        permission.permissionId === menuItem.permissionId,
    );

    // If the menu item has a submenu, filter the submenu items
    if (menuItem.subMenu) {
      menuItem.subMenu = menuItem.subMenu.filter((subMenuItem) =>
        rolePermissions.some(
          (permission) =>
            permission.permissionCategoryId ===
            subMenuItem.permissionCategoryId &&
            permission.permissionId === subMenuItem.permissionId,
        ),
      );
      // Show the menu item if it has a non-empty submenu
      return menuItem.subMenu.length > 0;
    }

    // Show the menu item if it has permission
    return hasPermission;
  });

  return filtered;
};
